import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import OutlineCard from "../../OutlineCard";

const PRIORITY_COLORS = {
  high: "error",
  medium: "warning",
  low: "success",
};

const ActionList = ({ title, items }) => (
  <OutlineCard title={title}>
    {Array.isArray(items) && items.map((item, i) => (
      <Row key={i} spacing="200" alignmentVertical="center">
        <Text type="b200" color={PRIORITY_COLORS[item.priority] || "secondary"}>●</Text>
        <Text type="b200" color="secondary">{item.text}</Text>
      </Row>
    ))}
  </OutlineCard>
);

export default ActionList;
